import { z } from 'zod';

export const certificateSchema = z.object({
  id: z.string().uuid(),
  cnpjId: z.string().uuid(),
  holderName: z.string(),
  holderCnpj: z.string(),
  issuedAt: z.string(),
  expiresAt: z.string(),
  status: z.string(),
  uploadedAt: z.string(),
  daysToExpire: z.number(),
});
export type Certificate = z.infer<typeof certificateSchema>;

export type ExpirationLevel = 'ok' | 'warning' | 'danger';

export function expirationLevel(daysToExpire: number): ExpirationLevel {
  if (daysToExpire < 30) return 'danger';
  if (daysToExpire <= 60) return 'warning';
  return 'ok';
}
